import root from 'window-or-global';

export const getStoreLink = (username, ref) => {
  if(ref) {
    return `${root.location.origin}/${username}/?ref=${ref}`;
  }
  return `${root.location.origin}/${username}/`;
};



// WEBPACK FOOTER //
// ./src/product/utils/ProductUtils.js